import React, { useState, useEffect } from 'react'

export default function TipModal({ onCloseClick, id }) {

    const [amount, setAmount] = useState(-0.21)
    const [agreed, setAgreed] = useState(0)

    useEffect(() => {
        amount > 0 ? setAmount(amount) : setAmount(0)
    }, [amount])

    const sleep = async (ms) => {
        return new Promise(resolve => setTimeout(resolve, ms))
    }

    const init = async () => {
        document.getElementById(id).style.transform = 'scale(1)'
        await sleep(1500)
    }
    useEffect(() => {
        init()
    }, [])

    return (
        <div id={id} className='feed-tip-modal'>
            <div className="feed-tip-modal-header">
                <div className="col-1">
                    <img src={require('../../assets/icons/notifiertip.svg')} />
                    <div className="col-2">
                    Send tip
                    </div>
                </div>
                <div className="col-3">
                    <img onClick={onCloseClick} src={require('../../assets/icons/notifcross.svg')} />
                </div>
            </div>

            <div className="feed-tip-modal-body">
                <h5>Select your amount to tip @username ‘s photo</h5>
                <div className="feed-tip-modal-input-wrapper">
                    <div className="wrapper-col-1">
                        <div className="inner-col-1">
                            <h3><span>$ </span>&nbsp;Amt</h3>
                        </div>
                        <div className="inner-col-2">
                            <input onChange={e => setAmount(e.target.value)} type="number" />
                        </div>
                    </div>

                    <div className="wrapper-col-2">
                        <h3>+$0.21 <span>&nbsp;(VAT)</span></h3>
                    </div>
                </div>
                <div className="feed-tip-total-cost">
                    Total: ${parseFloat(amount) + 0.21} USD
                </div>

                <div className="feed-tip-modal-footer">
                    <div className="feed-tip-modal-footer-consent">
                        <img onClick={e => setAgreed(!agreed)} src={agreed == 1 ? require('../../assets/icons/tipmodaltick.svg') : require('../../assets/icons/tipmodaluntick.svg')} />
                        <p onClick={e => setAgreed(!agreed)}>Confirm </p>
                    </div>
                    <div className="feed-tip-modal-button">
                        SEND TIP
                    </div>
                </div>
            </div>
        </div>
    )
}
